/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetServerSideProps } from 'next';

import { PageRendererComponent, prePageCall } from '@marriott/mi-headless-utils';
import { mockModel } from '../../mocks/mockModel';
import { getContentUrl } from '@marriott/mi-leisure-components/utils';
import { NEXT_PUBLIC_ENV_KEYS, RESORT_CONTENT_ROOT } from '@marriott/mi-leisure-components/constants';
import leisureSignatures from '../../signatures/leisureSignatures.json';
import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';

function pageRenderer(props) {
  console.log('[page] props ', props);
  return <PageRendererComponent {...props} />;
}

//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
const leisureSpecificData = async (context: any) => {
  console.log('Leisure Resolved URL:', context?.resolvedUrl);
  const uri = getContentUrl(context, RESORT_CONTENT_ROOT);

  // Feature flag call to get cardCarousel flag
  const featureFlags = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_CAROUSEL_LIGHTINING_VARIANTS, {
    target: TARGETS.APP.LEISURE_RENDERER,
  });
  // Feature flag call for logo automation
  const featureFlagLogo = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION, {
    target: TARGETS.APP.OFFERS_RENDERER,
  });

  return {
    operationSignatures: leisureSignatures,
    uri: uri,
    nextPublicEnvKeys: NEXT_PUBLIC_ENV_KEYS,
    featureFlags: { featureFlagLogo, featureFlags },
  };
};

//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
export const getServerSideProps: GetServerSideProps<any> = prePageCall(leisureSpecificData, mockModel);
export default pageRenderer;
